import SEOHead from '@/components/common/SEOHead'
import { Container, EditorialList } from '@/components/ui'
import { Link } from 'react-router-dom'

const AboutPage = () => {
  const values = [
    {
      title: 'Chất lượng Giáo dục Vượt trội',
      body: 'Chúng tôi cam kết mang đến chương trình giảng dạy chất lượng cao, cập nhật và phù hợp với thực tế, được thiết kế bởi các chuyên gia hàng đầu trong ngành.',
    },
    {
      title: 'Cộng đồng gắn kết',
      body: 'Chúng tôi xây dựng một môi trường học tập hỗ trợ, nơi mọi cá nhân đều cảm thấy được tôn trọng, được trao quyền và có thể phát triển hết tiềm năng của mình.',
    },
    {
      title: 'Thành công là thước đo',
      body: 'Chúng tôi đánh giá thành công của mình bằng sự phát triển nghề nghiệp và những thành tựu lâu dài của học viên. Bởi lẽ, thành công của bạn chính là mục tiêu cuối cùng của chúng tôi.',
    },
    {
      title: 'Giảng viên tận tâm',
      body: 'Đội ngũ giảng viên của chúng tôi không chỉ truyền đạt kiến thức mà còn là những người cố vấn đầy nhiệt huyết, sẵn sàng đồng hành và truyền cảm hứng cho học viên trên con đường sự nghiệp.',
    },
  ]

  return (
    <div className="bg-eh-cream eh-section">
      <Container>
        <SEOHead
          title="Về Trung tâm M2MBA | Đào tạo Business Analyst chất lượng cao"
          description="Trung tâm M2MBA đồng hành cùng hơn 1500 học viên trong và ngoài nước trên hành trình sự nghiệp BA. Chúng tôi cam kết đào tạo thực tiễn, chất lượng và mang lại sự thay đổi bền vững."
          image="https://storage.googleapis.com/m2mba/f4872d86-57b4-4bb8-9492-f14a60f22280.jpg"
          url="https://m2mba.com/about"
          type="website"
          author="Trung tâm M2MBA"
          keywords="khóa học business analyst, khóa học BA, đào tạo BA, BA cho người bắt đầu,AI,Automation Workflow, n8n,bmad method, API, Database, SQL, tích hợp hệ thống"
          tags={['Business Analyst', 'Khóa học BA', 'Đào tạo BA', 'AI', 'Automation','n8n','API','Database','SQL','tich hợp hệ thống']}
          noindex={false}
          publishedTime="2019-01-01T00:00:00Z"
          modifiedTime={new Date().toISOString()}
         />

        <div className="mx-auto max-w-2xl border-b border-eh-border pb-10 text-center">
          <p className="eh-eyebrow">Câu chuyện M2MBA</p>
          <h1 className="eh-display">
            Trung tâm M2MBA
          </h1>
          <p className="mt-4 text-lg text-eh-muted">
            Trao quyền cho chuyên gia để phát triển sự nghiệp bằng các chương trình đào tạo thực tiễn, chất lượng cao.
          </p>
        </div>

        <div className="mt-12 grid items-start gap-10 lg:mt-16 lg:grid-cols-2 lg:gap-14">
          <div>
            <h2 className="eh-title">
              Sứ mệnh của chúng tôi
            </h2>
            <p className="mt-4 text-base leading-relaxed text-eh-muted md:text-lg">
              Sứ mệnh của M2MBA là đồng hành cùng bạn trên con đường phát triển sự nghiệp. Trong 6 năm qua, chúng tôi đã trở thành cầu nối giúp hơn 1500 học viên trong và ngoài nước trang bị kiến thức để tự tin chuyển mình sang nghề Phân tích nghiệp vụ (BA) đầy tiềm năng.
            </p>
            <p className="mt-4 text-base leading-relaxed text-eh-muted md:text-lg">
              Chúng tôi hiểu rằng thành công không đến từ con đường dễ dàng. Các khóa học của chúng tôi được nhận xét là có khối lượng kiến thức lớn, nhưng chính sự quyết tâm và nỗ lực của bạn sẽ được đền đáp bằng một sự nghiệp vững vàng. Mọi khóa học đều được chắt lọc tinh túy, chỉ tập trung vào những kiến thức thiết yếu nhất cho công việc thực tế. Quan trọng hơn, chúng tôi cam kết một sự quan tâm đặc biệt: mỗi bài tập của bạn đều được kiểm tra, chữa và góp ý chi tiết, để đảm bảo bạn không chỉ &quot;học&quot; mà còn &quot;hiểu thật sâu&quot;.
            </p>
          </div>
          <div>
            <img
              className="w-full border border-eh-border object-cover shadow-eh-soft"
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80"
              alt="Students collaborating"
            />
          </div>
        </div>

        <div className="mt-16 md:mt-20">
          <div className="mx-auto mb-8 max-w-2xl text-center md:mb-10">
            <h2 className="eh-title">
             Giá Trị Cốt Lõi Của Chúng Tôi
            </h2>
            <p className="mt-4 text-lg text-eh-muted">
              Những giá trị này là kim chỉ nam cho mọi hoạt động của chúng tôi, kiến tạo nên một trải nghiệm học tập độc đáo và chất lượng.
            </p>
          </div>
          <EditorialList
            items={values.map((value) => ({
              title: value.title,
              body: value.body,
            }))}
          />
        </div>

        <div className="mt-16 border border-eh-border bg-eh-keylime px-6 py-12 text-center md:mt-20 md:px-14 md:py-16">
          <h2 className="eh-title mx-auto max-w-2xl">
            Bạn đã sẵn sàng để bắt đầu hành trình học tập của mình chưa?
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-lg leading-8 text-eh-muted">
           Hãy tham gia cộng đồng của chúng tôi và cùng nhau tiến những bước vững chắc trên con đường phát triển sự nghiệp.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link to="/courses" className="eh-btn">
              Khám phá khóa học
            </Link>
            <Link to="/contact" className="eh-btn-secondary">
              Liên hệ chúng tôi<span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default AboutPage
